import * as React from "react";
import type { SVGProps } from "react";
const SvgLiftCabinSmall = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g fill="currentColor" clipPath="url(#lift-cabin-small_svg__a)">
      <path d="M17.13 22H7.75c-.97 0-1.88-.7-2.13-1.62-.83-3.19-.83-6.56 0-9.74.25-.93 1.17-1.63 2.13-1.63h9.38c.97 0 1.89.7 2.13 1.62.83 3.19.83 6.56 0 9.74-.25.92-1.18 1.63-2.13 1.63m0-11H7.76c-.06 0-.18.09-.2.15-.74 2.85-.74 5.86 0 8.72.02.04.14.13.2.13h9.37c.06 0 .18-.09.2-.15.74-2.84.74-5.86 0-8.72-.02-.04-.14-.13-.2-.13" />
      <path d="M12.44 22c-.55 0-1-.45-1-1V5c0-.55.45-1 1-1s1 .45 1 1v16c0 .55-.45 1-1 1" />
      <path d="M18.72 18H6.17c-.55 0-1-.45-1-1s.45-1 1-1h12.55c.55 0 1 .45 1 1s-.45 1-1 1M8.44 7c-.4 0-.79-.25-.94-.65-.19-.52.07-1.09.58-1.29l8.01-3c.52-.19 1.09.07 1.29.59.19.52-.07 1.09-.58 1.29l-8.01 3c-.12.04-.23.06-.35.06" />
    </g>
    <defs>
      <clipPath id="lift-cabin-small_svg__a">
        <path fill="#fff" d="M5 2h14.88v20H5z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgLiftCabinSmall;
